var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneRelatedImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "192px",
    height: "95px",
    viewBox: "0 0 192 95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "13.3893725 0 0 0 2.3331399 16.9899312 11.0562326 16.9899312"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-3",
    points: "21 70 7 70 9.43954364 88 18.5604564 88 21 70"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.4_\\u6280\\u672F\\u652F\\u6301_\\u5DE5\\u5355\\u5217\\u8868_\\u5DE5\\u5355\\u8BE6\\u60C5",
    transform: "translate(-968.000000, -1818.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(968.000000, 1818.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,84 L190,84 C191.104569,84 192,84.8954305 192,86 L192,93 C192,94.1045695 191.104569,95 190,95 L2,95 C0.8954305,95 1.3527075e-16,94.1045695 0,93 L0,86 C-1.3527075e-16,84.8954305 0.8954305,84 2,84 Z",
    id: "\\u77E9\\u5F62",
    fill: "#E7EFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(54.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-154",
    fill: "#3F8CFF",
    points: "25 59 102.641774 59 126 0 48.4767703 0 25 59"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-155",
    fill: "#0058DB",
    points: "102.806932 58 0.494127113 58 0 62 101.598879 62 103 58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8430219,29.497662 C82.4541789,27.5664663 81.2267291,26 79.100519,26 C76.9794447,26 74.7659264,27.5664663 74.1547694,29.497662 C73.5487482,31.4288577 74.776198,33 76.8972723,33 C79.0234824,33 81.2370006,31.4288577 81.8430219,29.497662",
    id: "Fill-156",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "illustration",
    transform: "translate(26.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3702135,73.6379321 C19.5253658,73.4095917 22.6419934,71.0100688 25.1822261,64.382741 C26.6326627,60.5968098 30.7233349,41.0740922 25.1822261,39.7032703 C19.6403298,38.331669 20.6797306,48.1581009 20.6797306,57.1841723 C20.6797306,62.6877224 18.3702135,73.6379321 18.3702135,73.6379321",
    id: "Fill-890",
    fill: "#42D1D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8307683,74.5520732 C18.7450277,74.3595814 18.139498,45.1873373 18.3702135,38.331669 C18.6017164,31.4760007 19.9867967,5.88238895 16.0614838,1.76914383 C12.1361708,-2.34410129 8.09589373,1.31246296 7.74942679,6.62507985 C7.58485499,9.14383851 8.44236068,27.4773155 8.90379165,32.7330421 C9.36601005,37.9887687 9.94319249,49.8718232 10.4046235,57.4132921 C10.8668419,64.9539817 12.3668862,74.7804136 15.8307683,74.5520732",
    id: "Fill-891",
    fill: "#42D1D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4046235,74.8941942 C10.4046235,74.8941942 3.9351407,62.2629936 2.32328198,52.4996865 C-0.562630177,35.0180051 -1.13981261,17.9937839 2.78550038,18.2221243 C6.71002595,18.4512441 6.99428633,35.5915838 7.17224436,42.9023743 C7.63367533,61.8694375 12.1361708,73.7517127 12.1361708,73.7517127 L10.4046235,74.8941942",
    id: "Fill-892",
    fill: "#42D1D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9471592,74.3767264 L11.2471681,74.2699597 C11.2243328,74.2068349 8.94473775,67.9457869 7.43760654,63.7585065 C4.47925129,55.5366922 3.98789817,44.6044068 3.98396104,44.4953021 L3.66505397,44.5085505 C3.66977852,44.6184345 4.16270649,55.5966998 7.13759766,63.8644939 C8.64472887,68.0525536 10.9243239,74.3143809 10.9471592,74.3767264",
    id: "Fill-893",
    fill: "#1B54AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8630231,72.6092312 L15.1819302,72.6092312 C15.1819302,68.7079608 14.4952957,57.2901597 14.4889963,57.1748205 L14.1708766,57.1943035 C14.177176,57.3088634 14.8630231,68.7173126 14.8630231,72.6092312",
    id: "Fill-894",
    fill: "#1B54AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4985933,73.5264895 C19.5230035,73.4680406 21.9435476,67.6286041 23.3160291,62.3658637 C24.6916604,57.0890954 24.3633042,52.0819715 24.3593671,52.0320951 L24.0412474,52.0539161 C24.0451845,52.1030132 24.3696036,57.0618193 23.0073586,62.2863731 C21.640389,67.528072 19.2285066,73.3480255 19.2048838,73.4064744 L19.4985933,73.5264895",
    id: "Fill-895",
    fill: "#1B54AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2905356,57.4132921 C13.2905356,57.8863387 13.6787361,58.2697636 14.156703,58.2697636 C14.6346699,58.2697636 15.0228703,57.8863387 15.0228703,57.4132921 C15.0228703,56.9394662 14.6346699,56.5560413 14.156703,56.5560413 C13.6787361,56.5560413 13.2905356,56.9394662 13.2905356,57.4132921",
    id: "Fill-896",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3349273,52.1567862 C23.3349273,52.6306121 23.7223403,53.0140369 24.2003072,53.0140369 C24.6790616,53.0140369 25.0664746,52.6306121 25.0664746,52.1567862 C25.0664746,51.6837396 24.6790616,51.3003147 24.2003072,51.3003147 C23.7223403,51.3003147 23.3349273,51.6837396 23.3349273,52.1567862",
    id: "Fill-897",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95873386,44.5015367 C2.95873386,44.9753626 3.34614689,45.3587875 3.82411379,45.3587875 C4.30208069,45.3587875 4.69028115,44.9753626 4.69028115,44.5015367 C4.69028115,44.0284901 4.30208069,43.6450652 3.82411379,43.6450652 C3.34614689,43.6450652 2.95873386,44.0284901 2.95873386,44.5015367",
    id: "Fill-898",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-902",
    transform: "translate(8.558900, 71.010069)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-901"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-900",
    fill: "#FADFDC",
    mask: "url(#mask-2)",
    points: "0 2.79931346 13.3893725 2.79931346 13.3893725 1.42771221 0 1.42771221"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Fill-899",
    fill: "#3F8CFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-524",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "7 76.81 21 76.81 21 75.19 7 75.19"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneRelatedImg);
export default __webpack_public_path__ + "static/media/oneRelated-img.97e1bbc63a891c7e192352109fe5def3.svg";
export { ForwardRef as ReactComponent };